import LocationOrganizationsPage from './LocationOrganizationsPage';

export default function OrganizationsRedirectPage() {
  return <LocationOrganizationsPage defaultSlug="CA-ALL" />;
}
